import { GetServerSideProps } from 'next'

import Container from '@/components/Container/Container'
import { ExplicitHead } from '@/components/DefaultHead/DefaultHead'
import Mail from '@/components/Mail/Mail'
import Main from '@/components/Main/Main'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'

const DESTINATION = 'edhrec@edhrec.com'

type Props = {
  initCountry?: string
}

const ContactUs = () => {
  return (
    <Main>
      <Container small>
        <ExplicitHead
          description='Contact the EDHREC team'
          keywords='EDHREC,contact,email,message'
          title='Contact Us | EDHREC'
        />
        <SimpleHeader>Contact Us</SimpleHeader>
        <Mail
          description={
            <>
              <p>
                SCM Headquarters
                <div className='mt-1 ms-3'>
                  8174 Lark Brown Rd
                  <br />
                  Unit 101
                  <br />
                  Elkridge, MD 21705
                </div>
              </p>
              <p>
                {'Use the form below, or email us at '}
                <a href={`mailto:${DESTINATION}`} rel='noreferrer' target='_blank'>
                  {DESTINATION}
                </a>
                .
              </p>
            </>
          }
          destination={DESTINATION}
        />
      </Container>
    </Main>
  )
}

export const getServerSideProps: GetServerSideProps<Props> = async ({ req }) => {
  const props: Props = {}
  if (req.headers['cloudfront-viewer-country']) props.initCountry = req.headers['cloudfront-viewer-country'] as string
  return { props }
}

export default ContactUs
